var BaseStore = require('../BaseStore');
var Constants = require('../../constants/Constants');
var moment = require('moment');

var InvoiceStore = new BaseStore({
    defaultData: {invoices: [], total: 0, credits: []},
});

InvoiceStore.getUnpaid = function () {
    return this._data.invoices.filter(i => i.outstanding > 0);
};

InvoiceStore.register(Constants.api.GET_INVOICES, function (payload) {
    var action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;
        this.setData(action.response.body);

        return true;
    }
});
module.exports = InvoiceStore;




// WEBPACK FOOTER //
// ./app/stores/Invoice/InvoiceStore.js